import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOutstream = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7 6.49622V17.5038C7 18.0781 7.23582 18.5088 7.70747 18.796C8.17911 19.0831 8.64315 19.0672 9.09959 18.7481L17.361 13.1965C17.787 12.9093 18 12.5105 18 12C18 11.4895 17.787 11.0907 17.361 10.8035L9.09959 5.25189C8.64315 4.93283 8.17911 4.91688 7.70747 5.20403C7.23582 5.49118 7 5.92191 7 6.49622Z" })
});
export default SvgOutstream;
